/*eslint-disable import/prefer-default-export*/
import Fuse from 'fuse.js';

export const generateSearchResults = (products, options, searchTerm, offset) => {
  const fuse = new Fuse(products, options);
  return searchTerm.length > offset ? fuse.search(searchTerm) : [];
};
